import * as dropdown from "../../../_src/components/dropdown"

dropdown.toggleMenu()
